import { ContainedButton, Dialog, TextButton } from '@shared/components';
import { DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  itemsCount: number;
  onDelete: () => void;
  onClose: () => void;
  isLoading: boolean;
}

export const DeleteItemsDialog = ({ itemsCount, onDelete, onClose, isLoading }: Props) => {
  const t = useCampaignTFunction();
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>{t('campaign.columns.selection.remove.label')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('campaign.columns.selection.remove.info', { count: itemsCount })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <TextButton onClick={onClose} size="small">
          {t('campaign.cancel')}
        </TextButton>

        <ContainedButton loading={isLoading} onClick={onDelete} size="small">
          {t('campaign.columns.selection.remove.labelShort')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
};
